// extracted by mini-css-extract-plugin
export var breed = "comparisonTable-module--breed--02de1";
export var disclaimer = "comparisonTable-module--disclaimer--ee489";
export var insurerVinsurerMobile = "comparisonTable-module--insurerVinsurerMobile--2a8ec";
export var insurerVinsurerTable = "comparisonTable-module--insurerVinsurerTable--5ea72";
export var iviHead = "comparisonTable-module--iviHead--fc9da";
export var iviItem = "comparisonTable-module--iviItem--b7531";
export var iviItemCost = "comparisonTable-module--iviItemCost--a2181";
export var iviItemDetails = "comparisonTable-module--iviItemDetails--fdec3";
export var typecat = "comparisonTable-module--typecat--0fea9";
export var typedog = "comparisonTable-module--typedog--f2659";